import React, { FunctionComponent } from 'react';

type Props = {
  title: React.ReactNode;
  total: string;
  average: string;
  count: number;
};

const StatsCard: FunctionComponent<Props> = ({
  total,
  average,
  count,
  title
}) => {
  return (
    <div
      className="flex p-4 w-96 rounded-xl bg-white flex-col justify-between h-36"
      style={{
        background:
          'linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.25))',
        borderColor: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(8px)'
      }}
    >
      {title}
      <div className="flex justify-between">
        <div className="gap-1 flex flex-col">
          <span className="font-semibold text-sm">{total}</span>
          <span className="text-gray-600 text-xs">Total</span>
        </div>
        <div className="gap-1 flex flex-col">
          <span className="font-semibold text-sm">{average}</span>
          <span className="text-gray-600 text-xs">Promedio</span>
        </div>
        <div className="gap-1 flex flex-col">
          <span className="font-semibold text-sm">{count}</span>
          <span className="text-gray-600 text-xs">Cant.</span>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
